import { assetUrl } from '@/lib/api';
import type { MaintenanceEntry } from '@/types/api';

export function MaintenanceAttachments({ orderId, entry }: { orderId: string; entry: MaintenanceEntry }) {
  return (
    <div className="mt-2 space-y-2">
      {!!entry.attachments?.length && (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {entry.attachments.map((attachment) => {
            const url = assetUrl(
              `/api/service-orders/${orderId}/maintenance/${entry.id}/attachments/${attachment.id}/file`,
            );
            return (
              <figure key={attachment.id} className="min-w-0 rounded border p-2">
                {attachment.mimeType.startsWith('video/') ? (
                  <video controls preload="metadata" className="max-h-60 w-full" aria-label={attachment.originalName}>
                    <source src={url} type={attachment.mimeType} />
                    Seu navegador não reproduz este vídeo. Use o link abaixo para abri-lo.
                  </video>
                ) : (
                  <a href={url} target="_blank" rel="noreferrer">
                    <img
                      src={url}
                      alt={attachment.originalName}
                      loading="lazy"
                      className="max-h-48 w-full object-contain"
                    />
                  </a>
                )}
                <figcaption className="mt-1 truncate text-xs">
                  <a href={url} target="_blank" rel="noreferrer" className="underline">
                    {attachment.originalName}
                  </a>
                </figcaption>
              </figure>
            );
          })}
        </div>
      )}
    </div>
  );
}
